// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__3nMVh","Group":"Form_Group__-b0WS"};